module.exports = __webpack_public_path__ + "static/media/maintenance.822c4224.jpg";